// extracted by mini-css-extract-plugin
export default {"rootPdf":"pdfViewer_rootPdf__RELVh","pagging":"pdfViewer_pagging__992M8"};